import { styled, Tab as TabMui } from '@mui/material'

interface TabProps {
  width: number
}
export const Tab = styled(TabMui)<TabProps>(({ theme, width }) => ({
  minWidth: '20%',
  width: `${width}%`,
  borderBottom: `2px solid ${theme.palette.veryLightGray}`,
}))
